import { ILaundryContext } from "./LaundryProviderTypes"

export const LAUNDRY_INITIAL_CONTEXT: ILaundryContext = {
  laundry: null,
  laundryDataLoading: false,
  districts: [],
  currentHoliday: null,
  setCurrentHoliday: () => {},
  createUpdateLaundry: () => {},
  handleOpenedClosedCheckboxClick: () => {},
  laundriesCurrentPage: 1,
  changesHistory: [],
  approveRejectLaundryUpdates: () => {},
  approveRejectLaundryUpdatesLoading: false,
  enabled: false,
  enabledChangesHistory: false,
  laundryId: null,
  setState: () => {},
  searchValue: "",
  handleChangeCommission: () => {},
  discountTypes: [],
  // createUpdateLaundrySuccess: false,
  // createUpdateLaundryLoading: false
}
